import { classNameParser } from "../../../helpers";
import { Props } from "../../../types";

import "./style.css";

type SimpleProgressBarProps = Props<{
  completed: number;
  goal: number;
  progress?: number;
  unit?: string;
  height?: number;
}>;

export const SimpleProgressBar = (props: SimpleProgressBarProps) => {
  const normCompleted = Math.max(0, props.completed);
  const normGoal = Math.max(1, props.goal);
  const normProgress = Math.max(0, props.progress || 0);
  const completedPercentage = Math.min((normCompleted / normGoal) * 100, 100);
  const progressPercentage = Math.min((normProgress / normGoal) * 100, 100);
  return (
    <div className={classNameParser("w-full", props.className)} style={props.style}>
      <div className="relative">
        <div className="w-full rounded-[5px] bg-interface-150" style={{ height: props.height ?? 10 }} />
        {progressPercentage > completedPercentage && (
          <div
            className="simple-progress-bar--progress-bar"
            style={{
              width: `${progressPercentage > 0 ? `${progressPercentage}%` : "10px"}`,
              height: props.height ?? 10
            }}
          />
        )}
        {(completedPercentage || !progressPercentage) && (
          <div
            className="simple-progress-bar--paid-bar"
            style={{
              width: `${completedPercentage > 0 ? `${completedPercentage}%` : "10px"}`,
              height: props.height ?? 10
            }}
          />
        )}
      </div>
      {props.unit !== undefined ? (
        <div className="simple-progress-bar--info">
          <span className="">{normCompleted}</span>
          {" of "}
          <span className="">{normGoal}</span> {props.unit}
        </div>
      ) : null}
    </div>
  );
};
